const CHANGED_FILES_KEY = 'changedFiles';

export function getChangedFiles() {
  return JSON.parse(sessionStorage.getItem(CHANGED_FILES_KEY)) || [];
}

export function addChangedFile(file) {
  const changedFiles = getChangedFiles();
  if (!changedFiles.includes(file)) {
    changedFiles.push(file);
    sessionStorage.setItem(CHANGED_FILES_KEY, JSON.stringify(changedFiles));
  }
}

export function clearChangedFiles() {
  sessionStorage.setItem(CHANGED_FILES_KEY, JSON.stringify([]));
}

export function removeChangedFile(file) {
  const changedFiles = getChangedFiles().filter(f => f !== file);
  sessionStorage.setItem(CHANGED_FILES_KEY, JSON.stringify(changedFiles));
}
